import { Button } from './ui/button';

interface GameSettingsProps {
  difficulty: 'easy' | 'medium' | 'hard';
  onDifficultyChange: (diff: 'easy' | 'medium' | 'hard') => void;
  t: {
    chooseDifficulty: string;
  };
}

export function GameSettings({ difficulty, onDifficultyChange, t }: GameSettingsProps) {
  return (
    <div className="mt-8 text-center">
      <fieldset className="border-0 p-0 m-0 inline-block text-left">
        <legend className="block text-sm font-medium mb-2">{t.chooseDifficulty}</legend>
        <div className="flex justify-center gap-2 flex-wrap">
          {(['easy', 'medium', 'hard'] as const).map((d) => (
            <Button key={d} variant={difficulty === d ? 'default' : 'outline'} onClick={() => onDifficultyChange(d)}>
              {d.charAt(0).toUpperCase() + d.slice(1)}
            </Button>
          ))}
        </div>
      </fieldset>
    </div>
  );
}
